import { inject, Injectable } from '@angular/core';
import { BusinessNavDataService } from '@vendasta/business-nav';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PageId, PageIdToNavIdMap } from './page-id.enum';

@Injectable({ providedIn: 'root' })
export class PageAccessService {
  private navData = inject(BusinessNavDataService);

  isPageAccessible$(pageId: PageId | string): Observable<boolean> {
    return this.navData.navigationIds$.pipe(
      map((navIds) => {
        const navId = PageIdToNavIdMap[pageId];
        // When a nav ID is unknown, we assume it's accessible because it's likely custom, thus having no accessibility
        // controls of our own protecting it.
        return navId ? navIds.indexOf(navId) !== -1 : true;
      }),
    );
  }

  firstAccessiblePageUrl$(): Observable<string> {
    return this.navData.navigationLinks$.pipe(
      map((links) => links.filter((link) => link.serviceProviderId === 'VBC')),
      map((links) => {
        return links[0]?.path || 'account/select-location';
      }),
    );
  }
}
